export default "__VITE_ASSET__DlGYEjud__"